import { useEffect, useRef, useState } from 'react'

import { scrollToBlockBehavior } from './constants'
import { getBlockElementSelector, getCenteredScrollTop } from './helpers'

const useScrollToBlock = ({ layout }) => {
  const scrollContainerRef = useRef(null)
  const [blockIdToScroll, setBlockIdToScroll] = useState(null)

  useEffect(() => {
    if (!blockIdToScroll) return

    const container = scrollContainerRef.current
    const blockElement = container.querySelector(getBlockElementSelector(blockIdToScroll))

    if (!blockElement) return

    container.scrollTo({ top: getCenteredScrollTop(container, blockElement), behavior: scrollToBlockBehavior })
    setBlockIdToScroll(null)
  }, [blockIdToScroll, layout])

  return { scrollContainerRef, scrollToBlock: setBlockIdToScroll }
}

export default useScrollToBlock
